import { FunctionComponent } from "react";

import { BaseReportPage } from "./BaseReportPage";

const EngagementReportPage: FunctionComponent = () => {
    return <BaseReportPage />;
};

export default EngagementReportPage;
